import {inject} from '@angular/core';
import {CanActivateFn, CanDeactivateFn, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {Views} from '@ccp/config/views';
import {FeatureToggleService} from '@ccp/app/services/toggle-features/feature-toggle.service';
import {ToggleFeatures} from '@ccp/app/enums/toggleFeatures.enum';
import {RouterTrackerService} from '@ccp/services/router-tracker/router-tracker.service';
import {NgcsLeaveService} from '@ccp/app/services/ngcs-leave/ngcs-leave.service';

const NEW_SERVICE_PATH = 'new-service';
const REQUEST_SENT_PATH = 'new-service/request-sent';
const SERVICE_REVIEW_PATH = 'new-service/service-review';

export const NextgenCSActivateGuard: CanActivateFn = (route) => {
  const featureToggleService = inject(FeatureToggleService);
  if (featureToggleService.featureConfig$()?.getConfig(ToggleFeatures.nextgenCs)) {
    return true;
  } else {
    const router = inject(Router);
    return router.createUrlTree([Views.productRegisterScanQrCode.path], {
      queryParams: {...route.queryParams},
    });
  }
};

export const NextgenCSDeactivateGuard: CanDeactivateFn<unknown> = (
  _component,
  _currentRoute,
  _currentState,
  nextState: RouterStateSnapshot,
): Observable<boolean> | boolean => {
  const routerTracker = inject(RouterTrackerService);
  const ngcsLeaveService = inject(NgcsLeaveService);
  const router = inject(Router);

  const stack = routerTracker.getStack();
  const currentPath = RouterTrackerService.getCurrentPathFromStack(stack);
  const destinationUrl = nextState?.url ?? '';

  if (currentPath.includes(REQUEST_SENT_PATH) && destinationUrl.includes(SERVICE_REVIEW_PATH)) {
    router.navigate(['/' + Views.nextgenCs.path + '/request-service']);
    return false;
  }

  if (currentPath.includes(NEW_SERVICE_PATH) && !currentPath.includes(REQUEST_SENT_PATH)) {
    return ngcsLeaveService.confirmLeave();
  }

  return true;
};
